/**
 * Список origin'ов, чьи postMessage мы принимаем.
 *
 * Origin'ы Hub'а зашиты в код: полагаться только на env нельзя — VITE_* переменные
 * вшиваются на `docker build`, а в Nomad их задавали в RUNTIME-env, куда сборка уже
 * не заглядывает. В итоге список оказывался пустым, SDK отбрасывал INIT от Hub'а
 * (`https://qa-test-lens.amzhub.ai`), и плагин навсегда застревал на «Подключение к Hub».
 * Runtime-config и build-time env теперь РАСШИРЯЮТ встроенный список, а не заменяют его.
 */

const HUB_ORIGINS = [
  'https://qa-test-lens.amzhub.ai',
  'https://dev-aseller-lens.amzhub.ai',
  'https://stage-aseller-lens.amzhub.ai',
  'https://aseller-lens.amzhub.ai',
];

export function getAllowedOrigins(): string[] {
  const rc = (window as any).__RUNTIME_CONFIG__ as Record<string, string> | undefined;
  const raw = rc?.ALLOWED_ORIGINS || import.meta.env.VITE_ALLOWED_ORIGINS || '';
  const configured = raw
    .split(',')
    .map((s: string) => s.trim())
    .filter(Boolean);
  return Array.from(new Set([...HUB_ORIGINS, ...configured]));
}
